export const tabletMin = '(min-width: 768px)';
export const desktopMin = '(min-width: 1100px)';
